'use client';

import { useSession } from 'next-auth/react';
import { AuthData, transformSession } from '../util/transformSession';

export function useAuth(): AuthData {
  const sessionState = useSession();
  const session = sessionState.data;

  return transformSession(session);
}
